export const defaultState = {
    notificationPanelInfo: {
        lastSeen: null,
        notificationsOpened: {},
        count: 0

    },
    lastReadOfAChat: {
        // [requestId]: {
        //     timeToken: null,
        //     messageCount: 0,
        // }
    },


};

export default function user(state = defaultState, action) {
    switch (action.type) {
        case 'SET_LAST_SEEN_NOTIFICATION_PANEL': {
            return {
                ...state,
                notificationPanelInfo: {
                    ...state.notificationPanelInfo,
                    lastSeen: action.payload.timeToken,
                    count: 0
                },
                
            }
        }
        case 'SET_NOTIFICATION_OPENED': {
            return {
                ...state,
                notificationPanelInfo: {
                    ...state.notificationPanelInfo,
                    notificationsOpened: {
                        ...state.notificationPanelInfo.notificationsOpened,
                        [action.payload.requestId]: true
                    }
                }
            }
        }
        case 'SET_LAST_READ_OF_CHAT': {
            const input = action.payload
            const data = {
                timeToken: input.lastReadTime,
                messageCount: 0
            }

            return {
                ...state,
                lastReadOfAChat: {
                    ...state.lastReadOfAChat,
                    [input.requestId]: data
                }
            }
        }
        case 'SET_NOTIFICATION_COUNT': {
            const nI = action.payload
            const dataNC = state.notificationPanelInfo
            const count = (dataNC.lastSeen < nI.timeToken) ? dataNC.count + 1 : dataNC.count
            return {
                ...state,
                notificationPanelInfo: {
                    ...state.notificationPanelInfo,
                    count
                }
            }
        }
        case 'SET_NEW_CHAT_MESSAGE_COUNT': {
            const nI = action.payload

            const dataMC = state.lastReadOfAChat[nI.requestId]
            let count = 0;
            if (nI.requestId in state.lastReadOfAChat) {
                count = (nI.timeToken > dataMC.timeToken) ? dataMC.messageCount + 1 : dataMC.messageCount
            } else {
                count += 1
            }
            const newData = {
                timeToken: (dataMC) ? dataMC.timeToken : 0,
                messageCount: count
            }
            return {
                ...state,
                lastReadOfAChat: {
                    ...state.lastReadOfAChat,
                    [nI.requestId]: newData
                }
            }
        }
        default:
            return state;
    }
}
